import classNames from 'classnames';
import { observer } from 'mobx-react';

import SearchHistoryCrossIcon from '../../assets/search_history_cross_icon.svg';
import SearchHistoryIcon from '../../assets/search_history_icon.svg';
import { useStores } from '../../stores/useStores';

import styles from './GamesSearchHistory.module.scss';

export const GamesSearchHistory = observer(() => {
  const { gamesSearchStore } = useStores();

  const { searchHistory } = gamesSearchStore;

  if (!searchHistory.length) {
    return null;
  }

  return (
    <div className={styles.search_history}>
      {searchHistory.map((item, index) => {
        return (
          <button
            key={index}
            className={classNames('animation-slide-left', styles.search_history__item_container)}
            title={item}
            onClick={() => gamesSearchStore.selectSearchHistoryItem(index)}
          >
            <img alt="clock" className={styles.searchIcon} src={SearchHistoryIcon} />
            <span className={styles.itemText}>{item}</span>
            <button
              className={styles.removeSearchItem}
              onClick={(e) => {
                e.stopPropagation();
                gamesSearchStore.removeSearchHistoryItem(index);
              }}
            >
              <img alt="delete" className={styles.searchIcon} src={SearchHistoryCrossIcon} />
            </button>
          </button>
        );
      })}
    </div>
  );
});
